module.exports = __webpack_public_path__ + "static/img/govcard_white_08.557c3a9c.svg";